<template lang="pug">
  .BaseTooltip(@click="toggleShow" @mouseover="toggleShow(true)" @mouseleave="toggleShow(false)")
    IconTooltip
    Transition(name="tooltip")
      .BaseTooltip_wrapper(v-show="isShowing")
        .BaseTooltip_message {{tooltipMsg}}
          .BaseTooltip_icon




</template>

<script>
import IconTooltip from "@assets/icon-tooltip.svg";
export default {
  name: "BaseTooltip",
  components: {
    IconTooltip,
  },
  props: {
    tooltipMsg: {
      type: String,
      required: true,
      default: () => "Tooltip",
    },
  },
  data: () => ({
    isShowing: false,
  }),
  methods: {
    toggleShow(value = null) {
      if (value !== null) {
        this.isShowing = value;
      } else {
        this.isShowing = !this.isShowing;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@design";
.BaseTooltip {
  position: relative;
  cursor: help;
  &_wrapper {
    position: absolute;
    right: -0.6rem;
    bottom: 1.9rem;
    z-index: 100000000;
  }
  &_icon {
    z-index: 10000000;
    position: absolute;
    bottom: -0.3rem;
    right: 0.7rem;
    height: 1rem;
    width: 1rem;
    border-radius: 0.2rem;
    background: $primary-color;
    transform: rotate(45deg);
  }
  &_message {
    z-index: 1000000;
    width: 70vw;
    max-width: 16rem;
    padding: 0.8rem;
    background: $primary-color;
    color: #eae1f1;
    border-radius: 0.2rem;
    box-shadow: 0 0 0.5rem rgba(darken($primary-color, 50%), 0.5);
  }
}
</style>
